import { QBox, useCurrentUser } from '@qualio/ui-components';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { EditorMode } from '../../../util/EditModeUtils';
import { DocumentOverviewContext } from '../DocumentOverview/Context';
import {
  canUserEditDocument,
  canUserSuggestOnDocument,
} from '../DocumentOverview/RenderLogic';
import styles from './DocumentStatusBanner.module.css';

export const DocumentStatusBanner = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const { currentEditorMode, qualioDocument } = useContext(
    DocumentOverviewContext,
  );

  const overriddenQualioFrontendPadding = {
    width: 'calc(100% + 48px)',
    marginTop: '-10px',
    marginLeft: '-24px',
  };

  const isMultiRoot = qualioDocument.editor_version?.includes('multiroot');

  const isEditing = isMultiRoot
    ? canUserEditDocument(qualioDocument, currentUser)
    : currentEditorMode === EditorMode.EDIT;

  const isSuggesting = isMultiRoot
    ? canUserSuggestOnDocument(qualioDocument, currentUser) && !isEditing
    : currentEditorMode === EditorMode.TRACKCHANGES;

  if (isSuggesting) {
    return (
      <QBox
        data-cy="suggest-banner"
        style={overriddenQualioFrontendPadding}
        className={styles['document__status-banner-suggest']}
      >
        {t('messages.suggestingEdits')}
      </QBox>
    );
  } else if (isEditing) {
    return (
      <QBox
        data-cy="edit-banner"
        style={overriddenQualioFrontendPadding}
        className={styles['document__status-banner-edit']}
      >
        {t('messages.editingDocument')}
      </QBox>
    );
  }
  return (
    <QBox
      data-cy="view-banner"
      style={overriddenQualioFrontendPadding}
      className={styles['document__status-banner']}
    ></QBox>
  );
};
